import { ConfigSteps } from '@space-lib-events/toggleUnbanMemberCommunityModal'
import { Actions, ComponentNames, Entities, EventNames, ScreenNames } from '@space-lib/datahub'

export function getConfigMenuEvents(step: number, communityId?: number, communityName?: string) {
  const COMMUNITY_CONFIG_MENU_EVENTS = {
    [ConfigSteps.GENERAL_CONFIG]: {
      entity: Entities.COMMUNITY,
      action: Actions.SETUP,
      event: {
        eventName: EventNames.GO_TO_GENERAL_CONFIG,
        screenName: ScreenNames.COMMUNITY_CONFIGURATION_MODAL_GENERAL_CONFIG,
        communityId,
        communityName
      }
    },
    [ConfigSteps.ACCESS_AND_PRIVACY]: {
      entity: Entities.COMMUNITY,
      action: Actions.SETUP,
      event: {
        eventName: EventNames.GO_TO_PRIVACY_AND_ACCESS,
        screenName: ScreenNames.COMMUNITY_CONFIGURATION_MODAL_ACCESS_AND_PRIVACY,
        communityId,
        communityName
      }
    },
    [ConfigSteps.MEMBERS_AND_PERMISSIONS]: {
      entity: Entities.MEMBERS_AND_PERMISSIONS,
      action: Actions.SETUP,
      event: {
        eventName: EventNames.GO_TO_MEMBERS_AND_PERMISSIONS,
        screenName: ScreenNames.COMMUNITY_EDIT_VIEW,
        componentName: ComponentNames.CONFIGURATION_MODAL
      }
    },
    [ConfigSteps.UNBAN_MEBER]: {
      entity: Entities.BAN,
      action: Actions.SETUP,
      event: {
        eventName: EventNames.COMMUNITY_CONFIG_BLOCK_LIST,
        screenName: ScreenNames.COMMUNITY_EDIT_VIEW,
        componentName: ComponentNames.CONFIGURATION_MODAL
      }
    }
  }

  return COMMUNITY_CONFIG_MENU_EVENTS[step]
}
